import Title from "../Title/Title";
import "./ReadMoreSection.css";

export default function ReadMoreSection({ items }) {
  return (
    <div className="read-more-container">
      {items.map((item, index) => (
        <div key={index} className="read-more-item">
          <Title text={item.title} size="1.1rem" color="var(--color-blue)" />
          <p className="read-more-subtitle">{item.subTitle}</p>
          <a href={item.link} className="read-more-link">Read More »</a>
        </div>
      ))}
    </div>
  );
}
